<template>
  <div class="form-group row">
    <label class="col-4 text-right">{{ label }}</label>
    <div class="col-8 d-flex justify-content-between range-slider">
      <input
        type="range"
        step="1"
        min="0"
        max="10"
        class="custom-range range-slider__range"
        :id="`customRange${label}`"
        v-model.number="valueLocal"
        @change="modelChange"
      />
      <label class="range-slider__value">{{ valueLocal }}</label>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class AppCompoundRating extends Vue {
  @Prop()
  label?: string;

  @Prop()
  value?: number;

  valueLocal?: number = this.value;

  @Watch("value")
  onRatingValueChange(val: number) {
    this.valueLocal = val;
  }

  modelChange() {
    this.$emit("input", this.valueLocal);
  }
}
</script>

<style scoped lang="scss">
.range-slider {
  &__range {
    width: 90%;
    margin-top: 0.15rem !important;
  }

  &__value {
    display: inline-block;
    position: relative;
    top: -3px;
    width: 45px;
    color: #fff;
    line-height: 20px;
    text-align: center;
    border-radius: 3px;
    background: #2c3e50;
    padding: 5px 10px;
    margin-left: 8px;

    &:after {
      position: absolute;
      top: 8px;
      left: -7px;
      width: 0;
      height: 0;
      border-top: 7px solid transparent;
      border-right: 7px solid #2c3e50;
      border-bottom: 7px solid transparent;
      content: "";
    }
  }
}
</style>
